import React from 'react';
import { Tabs} from 'antd';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import { Workload } from './Workload';
import { CAT } from './CAT';
import {Result} from './Result';
export const Count: React.FC = () => {
  
  return (
    <>
    <Tabs defaultActiveKey="1" tabPosition="left">
    <TabPane tab="工作量统计" key="1">
      <Workload/>
    </TabPane>
    <TabPane tab="CAT等级占比统计" key="2">
      <CAT/>
    </TabPane>
    <TabPane tab="患龋风险等级占比统计" key="3">
      <Result/>
    </TabPane>
  </Tabs>
    </>
  )
};